<mat-card class="portal-card" [style.overflow]="'auto'" [style.height.px]="'270px;'" [style.minHeight]="'270px;'">
  <mat-card-content fxLayout="row wrap" fxLayoutGap="1.5% grid" class="card-content">
       <app-empcard *ngFor="let em of newemps" [employee]="em">
          </app-empcard>
  </mat-card-content>
</mat-card>
